import { render } from "./AccessUsersToOnlineOrders.vue?vue&type=template&id=25cbbd81&scoped=true"
import script from "./AccessUsersToOnlineOrders.vue?vue&type=script&lang=js"
export * from "./AccessUsersToOnlineOrders.vue?vue&type=script&lang=js"

import "./AccessUsersToOnlineOrders.vue?vue&type=style&index=0&id=25cbbd81&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cbbd81"]])

export default __exports__